import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

/**
 * Component that renders skeleton placeholders for marker items.
 * Uses the NgxSkeletonLoaderModule to show loading UI while marker data is being prepared.
 */
@Component({
  selector: 'app-marker-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './marker-skeleton.html',
  styleUrl: './marker-skeleton.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkerSkeleton {
  /**
   * Number of marker skeleton elements to render.
   * This value is supplied as an input to the component and is required for proper rendering.
   */
  readonly numbersLoading = input.required<number>();

  /**
   * Computes an array of indices used to iterate and render the requested number of skeletons.
   * Produces a sequence starting at 0 and ending at numbersLoading - 1.
   */
  protected readonly numbersIterate = computed<number[]>(() =>
    Array(this.numbersLoading())
      .fill(0)
      .map((x, i) => i),
  );
}
